import { EventNames } from '../../../types/misc.types'
import { trackEvent } from '../../../utils/appBridge'
import InPlaceNameValueAccordion from '../../ui-components/InPlaceNameValueAccordion'
import { roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'
import { TaxInfo } from '../../../types/rebalance'
import STCG from './STCG'
import LTCG from './LTCG'
import { TaxCategories } from '../../../types/mutual-fund-detail.types'

type TaxLiabilityAccordionProps = {
  accordionOpen: boolean
  setAccordionOpen: (value: boolean | ((prev: boolean) => boolean)) => void
  netTaxLiability: number
  stcgTaxInfo: TaxInfo
  ltcgTaxInfo: TaxInfo
  taxCategory: `${TaxCategories}`
}

export default function TaxLiabilityAccordion({
  accordionOpen,
  setAccordionOpen,
  netTaxLiability,
  stcgTaxInfo,
  ltcgTaxInfo,
  taxCategory
}: TaxLiabilityAccordionProps) {
  return (
    <div
      style={{
        width: accordionOpen ? 'calc(100% + 12px)' : '100%',
        marginLeft: accordionOpen ? '-6px' : '0px'
      }}
      className={accordionOpen ? 'px-4' : 'px-5'}
    >
      <InPlaceNameValueAccordion
        name='Estimated Tax Liability'
        nameClassName='text-[#6A6E6E] !font-[400] !text-[14px]'
        accordionClassName={`${accordionOpen ? '!bg-[#F0F4F7]' : ''}`}
        alwaysShowValue={true}
        value={roundOffAndFormatNumberWithCurrency(netTaxLiability).toString()}
        isExpanded={accordionOpen}
        onAccordionClick={() => {
          trackEvent({
            eventName: EventNames.UserClicked,
            payload: {
              eventId: 'ExitLoadAndTax',
              responseName: 'Expand',
              screenType: 'REBALANCE_PLAN_PAGE'
            }
          })
          setAccordionOpen((isExpanded) => !isExpanded)
        }}
      >
        {/* Children are only rendered when the accordion is open */}
        <div className='flex flex-col gap-4 pt-2'>
          <div className='flex flex-col gap-4'>
            <STCG stcgTaxInfo={stcgTaxInfo} taxCategory={taxCategory} />
          </div>
          <div className='flex flex-col gap-4'>
            <LTCG ltcgTaxInfo={ltcgTaxInfo} taxCategory={taxCategory} />
          </div>
        </div>
      </InPlaceNameValueAccordion>
    </div>
  )
}
